import MagnifyingGlassIcon from "@heroicons/react/24/solid/MagnifyingGlassIcon";
import XMarkIcon from "@heroicons/react/24/solid/XMarkIcon";

import { useBreakpointContext } from "@hsl/core/hooks/useBreakpoint";
import cx from "@hsl/core/utils/cx";

import Input from "../../components/Input";
import useTranslation, { Translate } from "../../hooks/useTranslation";

type Props = {
    value: string;
    placeholder?: string;
    placeholderShort?: string;
    onChange?(input: string): void;
    onSearch?(input: string): void;
    containerWidth?: number;
};

const SearchInput = ({
    value,
    placeholder = "Search",
    placeholderShort = placeholder,
    onChange,
    onSearch,
    containerWidth = Infinity,
}: Props) => {
    // const { searchEvent } = useYardActionEvents();
    const T = useTranslation();
    const inputPlaceholder =
        containerWidth < 376 ? placeholderShort : placeholder;

    const handleChange = (x: string) => onChange?.(x);
    const handleSearch = (x: string) => onSearch?.(x);

    const isActive = value && value.length > 0;

    return (
        <div className="flex items-center py-3">
            <Input
                iconProps={{
                    icon: (
                        <div
                            className={cx("@sm/main:block hidden h-auto", {
                                "cursor-pointer": isActive,
                            })}
                            onClick={() => handleChange("")}
                        >
                            {isActive ? (
                                <XMarkIcon width={25} color="#000" />
                            ) : (
                                <MagnifyingGlassIcon width={25} />
                            )}
                        </div>
                    ),
                    position: "left",
                }}
                containerClassNames="flex-1"
                className="@sm/main:text-base @sm/main:pl-[2.5rem] pl-2 text-sm"
                placeholder={T(inputPlaceholder).result}
                name="Fund Search"
                value={value}
                buttonProps={{
                    text: (
                        <Translate>
                            {isActive ? "Clear search" : "Search funds"}
                        </Translate>
                    ),
                    color: "primary",
                    className:
                        "font-normal text-[0px] @sm/main:text-sm @md/main:text-base @max-sm/main:p-3 @sm/main:px-4 gap-0 @max-sm/main:rounded-l-sm @sm/main:min-w-[126px]",
                    onClick: () => handleSearch(isActive ? "" : value),
                    icon: isActive ? (
                        <XMarkIcon className="@sm/main:hidden mx-0 h-5 w-5" />
                    ) : (
                        <MagnifyingGlassIcon className="@sm/main:hidden mx-0 h-5 w-5" />
                    ),
                }}
                onChange={(e) => handleChange(e.target.value)}
            />
        </div>
    );
};

export default SearchInput;
